import React from "react";
import { Roles } from "../../constants/data/Roles";
import { useAuth } from "../../context/AuthProvider";
import { ClinicUserManagement } from "./ClinicDetails/ClinicUserManagement/ClinicUserManagement";
import ClinicsGrid from "../ClinicsGrid/ClinicsGrid";
export default function ClinicManagement() {
  const auth = useAuth();
  return (
    <>
      {auth?.authClaims?.role.toUpperCase() === Roles.supportUser ||
      auth?.authClaims?.role.toUpperCase() === Roles.superUser && (
        <ClinicsGrid />
      )}
      {auth?.authClaims?.role.toUpperCase() === Roles.clinicAdmin && <ClinicUserManagement />}
    </>
  );
}
